module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    class: {
      maskStyle: 'true',
      isHidden: _vm.display
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("文件上传中,请稍等...")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ec510a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1850
// module chunks = 502